import { forwardRef } from "react";

import { SVGProps, Ref } from "react";

interface AISparkSvgProps extends SVGProps<SVGSVGElement> {
  title?: string;
  titleId?: string;
}

function StopIcon({ ...props }: AISparkSvgProps, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      aria-hidden="true"
      ref={ref}
      {...props}
    >
      <rect
        width="20"
        height="20"
        x="6"
        y="6"
        fill="var(--angelou-svg-primary-color, #1D1D1D)"
        stroke="var(--angelou-svg-primary-color, #1D1D1D)"
        stroke-linejoin="round"
        rx="2"
      ></rect>
    </svg>
  );
}

const ForwardRef = forwardRef(StopIcon);
export default ForwardRef;
